<template>
   <div class="gens-universesp">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../assets/images/gensunicerse/Header_1920x380_gene-blog.jpg" />
             <h1 class="gens-title">{{$t('NavabarText.navbr_jiyin')}}</h1>
       </div> -->
       <banner>
            <img src="../assets/images/gensunicerse/Header_1920x380_gene-blog.jpg"/>
            <div slot="title">{{$t('NavabarText.navbr_jiyin')}}</div>
        </banner>
       <div class="gens-info">
           <div class="gens-info-item" @click="jumpGensDetail('gensfourteen')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/201125-feature-measles.jpg"/>
               <div class="gens-info-item-tip">
                   <!-- {{$t('GensUniverseText.gens_tip_1')}} -->
                   葉酸代謝基因檢測 呵護媽媽同BB
               </div>
               <div class="gens-info-item-conten-abstract">
                   <!-- {{$t('GensUniverseText.gens_ontent_1')}} -->
                   葉酸和新生兒的神經管發育有很大的關聯，若孕婦再懷孕初期無法提供給胎兒足夠的葉酸，會增加胎兒神經管畸形的機率，且孕婦自身也容易產生貧血等症狀，流產、早產的機率也會增加。
               </div>
               <div class="gens-info-item-time">25 November, 2020</div>
               
           </div>
           <!-- 5个一组 start-->
           <div class="gens-info-item" @click="jumpGensDetail('gensone')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190927-feature-measles.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_1')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_1')}}
               </div>
               <div class="gens-info-item-time">27 September, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('genstwo')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190730-feature-ctdna.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_2')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_2')}}
               </div>
               <div class="gens-info-item-time">30 July, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensthree')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190725-feature-infant-food-allergy.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_3')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_3')}}
               </div>
               <div class="gens-info-item-time">25 July, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensfour')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190405-feature-pic.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_4')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_4')}}
               </div>
               <div class="gens-info-item-time">05 April, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensfive')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190329-feature-twins.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_5')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                 {{$t('GensUniverseText.gens_content_5')}}
               </div>
               <div class="gens-info-item-time">29 March, 2019</div>
               
           </div>
           <!-- 5个一组 end-->
           <!-- 5个一组 start-->
           <div class="gens-info-item" @click="jumpGensDetail('genssix')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190329-feature-twins.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_6')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                  {{$t('GensUniverseText.gens_content_6')}}
               </div>
               <div class="gens-info-item-time">15 March, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensseven')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/180919-feature-dr-chua.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_7')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_7')}}
               </div>
               <div class="gens-info-item-time">19 September, 2018</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('genseight')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190118-feature-vaccine.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_8')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_8')}}
               </div>
               <div class="gens-info-item-time">18 January, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensnine')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/181221-feature-talent.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_9')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_9')}}
               </div>
               <div class="gens-info-item-time">21 December, 2018</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensten')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/181002-feature-breast-cancer.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_10')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_10')}}
               </div>
               <div class="gens-info-item-time">02 October, 2018</div>
               
           </div>
           <!-- 5个一组 end-->

           <!-- 点击加载后 需要加载的数据 start -->
           <div class="gens-info-item" v-if="showmore" @click="jumpGensDetail('genseleven')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/170903-feature-down-syndrome.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_11')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                  {{$t('GensUniverseText.gens_content_11')}}
               </div>
               <div class="gens-info-item-time">03 September, 2017</div>
               
           </div>
           <div class="gens-info-item" v-if="showmore" @click="jumpGensDetail('genstwelve')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/180605-feature-dr-lam-tak-sum.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_12')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_12')}}
               </div>
               <div class="gens-info-item-time">05 June, 2018</div>
               
           </div>
           <div class="gens-info-item" v-if="showmore" @click="jumpGensDetail('gensthirteen')">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/170810-feature-plasma-dna-Screening.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_13')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_13')}}
               </div>
               <div class="gens-info-item-time">11 August, 2017</div>
               
           </div>
           <!-- 点击加载后 需要加载的数据 end -->

         
       </div>
        <div class="more-content" v-if="!showmore">
             <span class="show-more" @click="showmore=true">
                 <span v-if="$i18n.locale!='en-US'">了解更多</span>
                 <span v-if="$i18n.locale=='en-US'">Show more</span>
             </span>
        </div>
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
            showmore:false,
        }
    },
    components: {
      banner,
     
    },
    mounted(){

    },
    methods:{
        jumpGensDetail(path){

            this.$router.push({
            path: path
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.gens-universesp{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
   .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens-info{
        padding:25px 25px !important;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        .gens-info-item{
            cursor: pointer;
            background-color: #f4fcff;
            padding-bottom:15px;
            margin-bottom:25px;
            flex-basis: 18.7%;
            width:18.7%;
            display: block;
            .gens-info-item-img{
                position: relative;
                width: 100%;
                display: block;
            }
            .gens-info-item-tip{
                text-align: left;
                padding-left:10px;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
                color:#368da7;
                margin-top:10px;
                height: 50px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-bottom: 10px;
            }
            .gens-info-item-conten-abstract{
                text-align: left;
                padding:0 10px 0 10px ;
                color: #3a3a3a;
                font-size: 16px;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                height: 96px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
            }
            .gens-info-item-time{
                padding-left:10px;
                text-align: left;
                font-weight: 500;
                color:#3a3a3a;
                line-height: 27px;
                font-size:16px;
            }
        }

    }

    .more-content{
        margin-bottom:25px;
        .show-more{
            border-color: #368da7;
            background-color: #368da7;
            color:#fff;
            font-size: 14px;
            line-height: 36px;
            height: 36px;
            font-style: normal;
            font-weight: 400;
            border-radius: 5px;
            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            letter-spacing: 0;
            text-transform: none;
            border-width: 2px;
            border:solid 1px #368da7;
            padding:10px 20px;
            cursor: pointer;
        }
        .show-more:hover{
            background-color: #51cedd !important;
            border: solid 1px #51cedd !important;
        }
    }
     
           
}
</style>



// WEBPACK FOOTER //
// src/view/gensuniverse.vue